import LZString from 'lz-string';

export function getAccountsOperationsConfigurations() {
    const decompressed = LZString.decompressFromUTF16(localStorage.getItem('PACOUS'));
    const intervenerAccounts = JSON.parse(decompressed).private_area.accounts;

    return intervenerAccounts.map(account => {
        const cfg = {
            params: {
                $orderby: 'operation_date desc',
                $filter: '{"status":[{"eq":"FINALIZED"}]}',
                $limit: 20
            }
        };
        return {
            account,
            cfg
        };
    });
}

export function getProductKeys(responses) {
    let operations = [];
    responses.forEach(response => {
        operations = operations.concat(
            response.data.related_operations.map(op => `'${op.key_product}'`) || []
        );
    });

    // Eliminar duplicados
    const productList = operations.filter((op, index, self) => self.indexOf(op) === index);

    return productList;
}

export function getProductsParams(productKeys) {
    const params = {
        $orderby: 'net_asset_value_date desc'
    };

    if (productKeys.length) {
        params['$filter'] = `{"key_name":[{"ina": "(${productKeys})"}]}`;
    }

    return params;
}

export function getNetAssetValueDate(response) {
    // Obtener los productos ordenados por fecha reciente de valor liquidativo
    const valueDateProducts = response.data.products.filter(
        product => product.net_asset_value_date != null
    );
    const recentProductValueDate = new Date(valueDateProducts[0].net_asset_value_date);

    return recentProductValueDate;
}
